import React, {useEffect, useState} from 'react';
// design
import {
    Form,
    Input,
    Select,
    Button,
    message,
    Card,
    Layout,
    Badge,
    Divider,
    Checkbox,
    Radio,
    Modal,
    Upload,
    Typography,
    Collapse
} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
// router
import {
    BrowserRouter as Router,
    Link,
    useLocation
} from "react-router-dom";
// utils
import {dateFormat} from '../utils/dateFormat';
import slug from '../utils/slug';
import axios from 'axios';
import {taskStatusToText} from "../utils/helper";

const {Option} = Select;
const {Content} = Layout;
const {TextArea} = Input;
const {Title} = Typography;
const {Panel} = Collapse;

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function Task() {
    let query = useQuery();
    const [form] = Form.useForm();

    const formItemLayout = {
        labelCol: {
            xs: {span: 24},
            sm: {span: 9},
        },
        wrapperCol: {
            xs: {span: 24},
            sm: {span: 15},
        },
    };

    const [dataList, setDataList] = useState([]);

    async function fetchData() {
        axios.get(`/task/delegate`, {
            headers: {
                'Authorization': `Bearer ${query.get("token")}`
            }
        }).then((res) => {
            let data = res.data;
            if (data.length == 0) {
                data = null;
            }
            setDataList(data)
        }).catch(err => {
            setDataList(null);
        })
    }

    useEffect(() => {
        fetchData();
    }, []);

    const formSubmit = async (values, _id) => {
        axios.put(`/task/delegate`, {values, _id}, {
            headers: {
                'Authorization': `Bearer ${query.get("token")}`
            }
        }).then((res) => {
            if (res.status == 200) {
                message.success("İşlem başarılı.")
                fetchData();
            }
        });
    };

    // upload
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [fileList, setFileList] = useState([]);

    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    const handleCancel = () => setPreviewVisible(false);

    const handlePreview = async file => {
        file.preview = await getBase64(file?.originFileObj);
        setPreviewImage(file?.preview || file?.response.url)
        setPreviewVisible(true)
    };

    const handleChange = (files) => {
        const responseList = files.fileList.map(item => (
            item?.response &&
            item?.response
        ))
        setFileList(files.fileList)
        return responseList;
    };

    const uploadButton = (
        <div>
            <PlusOutlined/>
            <div style={{marginTop: 8}}>Yükle</div>
        </div>
    );

    return (
        <Layout className="layout" style={{minHeight: "100vh"}}>
            <div style={{width: "600px", maxWidth: "100%", margin: "0 auto"}}>
                <Content style={{padding: '24px'}}>
                    <div className="site-layout-content">
                        {!dataList &&
                            <Title mark level={3}>Aradığınız sayfa bulunamamakta veya erişim süresi dolmuştur.</Title>}
                        {
                            dataList?.map(data => (
                                <div key={data._id}>
                                    <Badge.Ribbon text={data?.is_completed ? "Tamamlandı" : "Tamamlanmadı"}
                                                  color={!data?.is_completed && "red"}>
                                        <Card style={{marginBottom: "16px"}}>
                                            <Divider>{data?.birthday_user?.name} {data?.birthday_user?.surname}</Divider>
                                            {data?.data?.taskStatus && <Divider style={{
                                                color: "gray",
                                                fontSize: 12
                                            }}>{taskStatusToText(data?.data?.taskStatus)}</Divider>}
                                            {
                                                data && !data?.is_completed &&
                                                <>

                                                    <h4>Adres</h4>
                                                    <p style={{margin: "0 0 8px 0"}}>{data?.birthday_user?.address}</p>
                                                    <Button type="primary" target="_blank"
                                                            href={`http://maps.google.com/?q=${encodeURI(data?.birthday_user?.address)}`}>Google
                                                        Maps</Button>
                                                    <br/><br/>
                                                    <h4>Telefon</h4>
                                                    <p style={{margin: 0}}>{data?.birthday_user?.phone}</p>
                                                    <br/>
                                                    <p style={{fontSize: "11px"}}>{dateFormat(data?.expiration_date)} tarihinde
                                                        görev sona eriyor.</p>

                                                    <Divider/>

                                                    <Collapse>
                                                        <Panel header="Değerlendirme Formu" key="1">
                                                            <Form {...formItemLayout} layout="horizontal"
                                                                  name="form_in_modal"
                                                                  initialValues={{modifier: 'public'}}
                                                                  onFinish={(values) => formSubmit(values, data._id)}>
                                                                <Form.Item name="taskStatus" label="Ziyaret Durumu">
                                                                    <Radio.Group>
                                                                        <Radio value="1">{taskStatusToText(1)}</Radio>
                                                                        <Radio value="2">{taskStatusToText(2)}</Radio>
                                                                        <Radio value="3">{taskStatusToText(3)}</Radio>
                                                                    </Radio.Group>
                                                                </Form.Item>
                                                                <Form.Item noStyle
                                                                           shouldUpdate={(prevValues, currentValues) => prevValues.taskStatus !== currentValues.taskStatus}>
                                                                    {({getFieldValue}) => {
                                                                        return getFieldValue('taskStatus') == '1' ? (
                                                                            <>
                                                                                <Form.Item name="score"
                                                                                           label="Etkinlik Değerlendirmesi">
                                                                                    <Radio.Group>
                                                                                        <Radio value="1">1</Radio>
                                                                                        <Radio value="2">2</Radio>
                                                                                        <Radio value="3">3</Radio>
                                                                                        <Radio value="4">4</Radio>
                                                                                        <Radio value="5">5</Radio>
                                                                                    </Radio.Group>
                                                                                </Form.Item>
                                                                                <Form.Item name="note"
                                                                                           label="Ziyaret Notları">
                                                                                    <TextArea rows={4}/>
                                                                                </Form.Item>
                                                                                <Form.Item label="Fotoğraflar">
                                                                                    <Form.Item name="photo"
                                                                                               getValueFromEvent={handleChange}
                                                                                               noStyle>
                                                                                        <Upload
                                                                                            multiple
                                                                                            name="file"
                                                                                            action={`${process.env.REACT_APP_API_PATH}/upload`}
                                                                                            listType="picture-card"
                                                                                            fileList={fileList}
                                                                                            onPreview={handlePreview}
                                                                                            onChange={handleChange}
                                                                                            headers={
                                                                                                {
                                                                                                    'Authorization': `Bearer ${query.get("token")} ${slug(data?.birthday_user?.name)}${slug(data?.birthday_user?.surname)}`
                                                                                                }
                                                                                            }
                                                                                        >
                                                                                            {fileList?.length >= 8 ? null : uploadButton}
                                                                                        </Upload>
                                                                                    </Form.Item>
                                                                                </Form.Item>
                                                                            </>
                                                                        ) : null
                                                                    }
                                                                    }
                                                                </Form.Item>


                                                                <Modal
                                                                    visible={previewVisible}
                                                                    title="Resim"
                                                                    footer={null}
                                                                    onCancel={handleCancel}
                                                                >
                                                                    <img alt="example" style={{width: '100%'}}
                                                                         src={previewImage}/>
                                                                </Modal>

                                                                <Form.Item>
                                                                    <Button shape="round" type="primary"
                                                                            htmlType="submit">
                                                                        Görevi tamamla
                                                                    </Button>
                                                                </Form.Item>
                                                            </Form>
                                                        </Panel>
                                                    </Collapse>
                                                </>
                                            }
                                        </Card>
                                    </Badge.Ribbon>
                                </div>
                            ))
                        }
                    </div>
                </Content>
            </div>
        </Layout>
    )
}
